module.exports = __webpack_public_path__ + "img/amsauction_logo.8df4e0be.png";